

















import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import isbot from "isbot";

const BaseGrid = () => import("./components/BaseGrid.vue");
const ImportantGrid = () => import("./components/ImportantGrid.vue");
import TheFooter from "./components/TheFooter.vue";
import ModalView from "./components/ModalView.vue";

@Component({
  components: {
    BaseGrid,
    TheFooter,
    ModalView,
    ImportantGrid,
  },
})
export default class extends Vue {
  @Watch("$route", { immediate: true })
  onRouteChange(to: Route, from: Route): void {
    if (to.meta.title) document.title = `${to.meta.title} | KH Item Tracker`;
    else document.title = "KH Item Tracker";
  }

  created() {
    if (!this.$store.state.settings.autosave) {
      this.$store.commit("tracker/resetState");
      this.$store.commit("tracker_important/resetState");
    }

    const oldIconSettings = this.$store.state.settings.iconStyle;
    if (oldIconSettings) {
      Object.entries(oldIconSettings).forEach(([key, value]) => {
        this.$store.commit("settings/setIconStyle", { name: key, value });
      });
      this.$store.commit("settings/wipeOldIconSettings");
    }

    ["size", "padding"].forEach(s => {
      const setting = this.$store.state.settings[s];
      if (setting && !isNaN(Number(setting))) {
        // @ts-ignore
        this.$store.commit("settings/setSettings", { [s]: setting + "px" });
      }
    });

    if (isbot(navigator.userAgent)) {
      // don't show changelog to bots/crawlers
      return;
    }

    if (this.$store.state.version !== this.$store.state.currVersion) {
      this.$router.push("changelog");
    }
  }

  get mainStyle(): object {
    if (!this.footer) {
      return {
        display: "flex",
        "align-items": "center",
        flex: 1,
      };
    }

    return {};
  }

  get importantMode(): boolean {
    return this.$store.state.settings.importantChecksMode;
  }

  get kh1fmMode(): boolean {
    return this.$store.state.settings.kh1fmMode;
  }

  get clients(): object {
    return this.$store.state.tracker.clients;
  }

  get footer(): boolean {
    return this.$route.query.footer !== "0";
  }

  handleClick(): void {
    if (!this.importantMode) {
      return;
    }

    this.$store.commit("tracker_important/selectLocation", "Free");
  }

  mounted(): void {
    document.body.onmousedown = (event: MouseEvent) => {
      if (event.button === 1)
        // Prevent autoscroll on middle click
        return false;
    };
  }
}
